export const APP_TITLE = 'Solve Finance Debt Optimizer';
export const SUPPORT_EMAIL = 'support@solve.finance';

export const TERMS_URL = 'https://solve.finance/tos';
export const PRIVACY_URL = 'https://solve.finance/privacy';
